/** Hack to work around GraphQL returning `string` which we then need to pass as a `number`-ish query parameter to the API */
export function queryParamNumberCast(value: string): number {
    return value as unknown as number;
}
